module.exports = {
	"description": "A list of home appliances",
	"appliances": [
		"air conditioner",
		"air fryer",
		"air ioniser",
		"aroma lamp",
		"attic fan",
		"bachelor griller",
		"back boiler",
		"barbecue",
		"beehive oven",
		"beverage opener",
		"boiler",
		"bread machine",
		"butane torch",
		"can opener",
		"ceiling fan",
		"central vacuum cleaner",
		"clothes dryer",
		"clothes iron",
		"coffee percolator",
		"coffeemaker",
		"combo washer dryer",
		"compactor",
		"convection heater",
		"convection microwave",
		"convection oven",
		"corn roaster",
		"crepe maker",
		"deep fryer",
		"dehumidifier",
		"dishwasher",
		"earth oven",
		"electric cooker",
		"electric water boiler",
		"embroidery machine",
		"energy regulator",
		"espresso machine",
		"fan heater",
		"field kitchen",
		"fire pot",
		"fireplace toaster",
		"flame supervision device",
		"flattop grill",
		"food steamer",
		"garbage disposal unit",
		"hair dryer",
		"hair iron",
		"halogen oven",
		"home server",
		"hot plate",
		"humidifier",
		"HVAC",
		"icebox",
		"instant hot water dispenser",
		"internet refrigerator",
		"kettle",
		"kimchi refrigerator",
		"kitchener range",
		"micathermic heater",
		"microwave oven",
		"mousetrap",
		"oil heater",
		"oven",
		"panini sandwich grill",
		"patio heater",
		"pneumatic vacuum",
		"popcorn maker",
		"pressure cooker",
		"pressure fryer",
		"radiator",
		"reflector oven",
		"refrigerator",
		"rice cooker",
		"rice polisher",
		"robotic vacuum cleaner",
		"rotisserie",
		"sandwich toaster",
		"self-cleaning oven",
		"set-n-forget cooker",
		"sewing machine",
		"slow cooker",
		"solar cooker",
		"sous-vide cooker",
		"soy milk maker",
		"stove",
		"sump pump",
		"susceptor",
		"swamp cooler",
		"tandoor",
		"thermal immersion circulator",
		"thermal mass refrigerator",
		"tie press",
		"toaster",
		"toaster oven",
		"trivet",
		"trouser press",
		"turkey fryer",
		"vacuum cleaner",
		"vacuum fryer",
		"vaporizer",
		"waffle iron",
		"washing machine",
		"water cooker",
		"water cooler",
		"water heater",
		"wet grinder",
		"window fan",
		"wood-fired oven"
	]
};


/** WEBPACK FOOTER **
 ** ./corpora/data/technology/appliances.json
 **/